require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 354
// module chunks = 0